export * from './text-editor.component';
